import { useEffect, useState } from "react";
import CardItem from "./CardItem";
import { a } from "../services/axiosInstance";
import Loading from "./Loading";
import Error from "./Error";

function CardList(){
    const [posts, setPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    useEffect(() => {
        async function fetchPosts() {
            try {
                setIsLoading(true);
                const res = await a.get('items/');
                setPosts(res.data)
                console.log(res.data)
            } catch (e) {
                setIsError(true);
                console.log(e);
            } finally{
                setIsLoading(false);
            }
        }
        fetchPosts();
    }, []);

    if (isError) {
        return <Error />
    }

    return(
        <div className="card-list">
            {isLoading ? (<Loading />) : (
                <>
                    {posts.map((post) => (
                        <CardItem key={post.id} post={post}/>
                    ))}
                </>
            )}
            
            {/* <CardItem /> */}
        </div>
    );
}

export default CardList;